import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const CostForm_FixedCost_Create_Mutation = graphql(`
  mutation CostForm_FixedCost_Create(
    $fixedCost: FixedCostInput!
    $versionData: VersionDataInput
  ) {
    createFixedCost(doc: $fixedCost, versionData: $versionData) {
      _id
    }
  }
`);

export type FixedCostInput = VariablesOf<
  typeof CostForm_FixedCost_Create_Mutation
>['fixedCost'];

export type FixedCost_Create_Result = ResultOf<
  typeof CostForm_FixedCost_Create_Mutation
>;

export const useCreateFixedCostMutation = () =>
  useGraphQLMutation(CostForm_FixedCost_Create_Mutation);
